import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];

  declare readonly contentTargets: HTMLElement[];

  toggle(event: Event) {
    event.preventDefault();
    this.contentTargets.forEach((target) => {
      target.hidden = !target.hidden;
    });
  }
}
